import React, { useEffect } from "react";
import { baseURL } from "../../../config";

const RedirectToApp = () => {
  useEffect(() => {
    const handleRedirect = async () => {
      // 1. Extract the referral code from the URL (e.g., /download?ref=DR-123)
      const urlParams = new URLSearchParams(window.location.search);
      const refCode = urlParams.get("ref");

      const isAndroid = /Android/i.test(navigator.userAgent);
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      let url = "exp+ceviliyar://expo-development-client/?url=http%3A%2F%2F192.168.0.4%3A8081";
      // 2. If there is a referral code, securely ping your backend to save the fingerprint
      if (refCode) {
        try {
          // We send the code and User-Agent. 
          // Note: The backend should capture the IP address from the request headers!
          await fetch(`${baseURL}/api/v1/store-referral`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code: refCode,
              userAgent: navigator.userAgent,
            }),
          });
        } catch (error) {
          console.error("Failed to store referral fingerprint:", error);
          // We continue to redirect even if this fails, so the user isn't stuck.
        }
      }

      // 3. Perform the actual App Store redirects
      if (isAndroid) {
        // THE ANDROID CHEAT CODE: Pass the referrer directly to the Play Store!
        let androidUrl = url;
        if (refCode) {
          androidUrl += `&referrer=${refCode}`;
        }
        window.location.href = androidUrl;
      } else if (isIOS) {
        // iOS: The App Store doesn't accept parameters like this.
        // We must rely entirely on the fingerprint we just saved to the backend above.
        window.location.href = url;
      } else {
        // Fallback (Defaults to Android)
        let fallbackUrl = url;
        if (refCode) {
          fallbackUrl += `&referrer=${refCode}`;
        }
        window.location.href = fallbackUrl;
      }
    };

    handleRedirect();
  }, []);

  return <div className="mb-10">Redirecting to the App Store...</div>;
};

export default RedirectToApp;
